var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')
var md5 = require("blueimp-md5")

module.exports = {
	data: function() {
		return {
			findWay: 'phone',
			findId: '',
			findInfo: '',
			showCode: false,
			code:'',
			schoolList: [],
			schoolId: null,
			verifyInfo: '',
			errorinfo: '',
			usertype: '',
			showCodeModal: false,
			verifyStage: 'code',
			verifyWay: '',
			verifyInfo: '',
		}
	},

	computed: {
		findTitle: function() {
			if(this.findWay=="phone") {
				return "通过已验证的手机接收验证码，并重设密码"
			} else if(this.findWay=="email") {
				return "通过已验证的邮箱接收验证码，并重设密码"
			} else if(this.findWay=="school"){
				return "重新验证校园账号，并重设密码"
			}
		},
		findHint: function() {
			if(this.findWay=="phone") {
				return "手机"
			} else if(this.findWay=="email") {
				return "邮箱"
			} else if(this.findWay=="school"){
				return "密码"
			}
		},
		findPlaceholder: function() {
			if(this.findWay=="phone") {
				return "请输入您绑定的手机号"
			} else if(this.findWay=="email") {
				return "请输入您绑定的邮箱"
			} else if(this.findWay=="school"){
				return "请输入南开URP或天大办公网密码"
			}			
		},
		findType: function() {
			if(this.findWay=="phone") {
				return "tel"
			} else if(this.findWay=="email") {
				return "email"
			} else if(this.findWay=="school"){
				return "password"
			}	
		},
	},

	compiled: function() {
		var info = po.schoolsinfo
		var options = []
		for(var key in info) {
			options.push({
				value: info[key].id,
				text: info[key].name,
				verifyinfo: '验证系统：' + info[key].verify +'(' +info[key].verifyurl +')'
			})
		}
		this.schoolList = options
	},

	methods: {
		onByPhone: function() {
			this.findWay = 'phone'
			this.findInfo = ''
		},
		onByMail: function() {
			this.findWay = 'email'
			this.findInfo = ''
		},
		onBySchool: function() {
			this.findWay = 'school'
			this.findInfo = ''
		},
		onSchoolChange: function() {
			for(var i in this.schoolList) {
				if(this.schoolList[i].value==this.schoolId) {
					this.verifyInfo = this.schoolList[i].verifyinfo
				}
			}
      refreshCode(this)
		},

		onSubmit: function() {
			if(this.findWay=="phone") {
				sendPhoneCode(this)
			} else if(this.findWay=="email") {
				sendEmailCode(this)
			} else if(this.findWay=="school") {
				verifyUserSchool(this)
			}
		},

		changeCode: function() {
			refreshCode(this)
		},
	},  

	components: {
    'custom-select': require('../controls/custom-select.vue'),
    'verifycode-modal': require('../components/verifycode-modal.vue'),
  }

}

function refreshCode(vuemodel) {
  yy_request.rest_api({
    method: 'get',
    api: 'school/' + vuemodel.schoolId + '/code/',
    opSuccess: function(info) {
      vuemodel.$$.verifycode.src = info.img
      vuemodel.showCode = true    	
    },
    opFail: function(info) {
      vuemodel.showCode = false
    },
  })
}

function sendPhoneCode(vuemodel) {
  yy_request.rest_api({
    method: 'post',
    api: 'password/phone/',
    data: {
			number: vuemodel.findId,
			phone: vuemodel.findInfo,    
    },
    opSuccess: function(info) {
			vuemodel.verifyStage = 'code'
			vuemodel.verifyWay = 'phone'
			vuemodel.verifyInfo = vuemodel.findInfo
			vuemodel.showCodeModal = true
    },
    opFail: function(info) {
			po.app.infoModalText = info
			po.app.showInfoModal = true
    },
  })
}

function sendEmailCode(vuemodel) {
  yy_request.rest_api({
    method: 'post',
    api: 'password/email/',
    data: {
			number: vuemodel.findId,
			email: vuemodel.findInfo,   
    },
    opSuccess: function(info) {
			vuemodel.verifyStage = 'code'
			vuemodel.verifyWay = 'email'
			vuemodel.verifyInfo = vuemodel.findInfo
			vuemodel.showCodeModal = true
    },
    opFail: function(info) {
			po.app.infoModalText = info
			po.app.showInfoModal = true
    },
  })
}

function verifyUserSchool(vuemodel) {
	var ajax_data = {
		number: vuemodel.findId,
		password: vuemodel.findInfo,
		sch_id: vuemodel.schoolId,
	}
	if(vuemodel.showCode) {
		ajax_data.code = vuemodel.code
	}
  yy_request.rest_api({
    method: 'post',
    api: 'password/verify/',
    data: ajax_data,
    opSuccess: function(info) {
			vuemodel.verifyStage = 'reset'
			vuemodel.showCodeModal = true
    },
    opFail: function(info) {
			po.app.infoModalText = info
			po.app.showInfoModal = true
    },
  })	
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/forget-view.vue
// module id = 152
// module chunks = 0